import React from 'react'

export default class Section extends React.Component {
  render() {
    return <div>{this.props.children}</div>
  }
}
